import { z } from 'zod';

/** Request body for `POST /lasso/v1/prompt` (orchestrator-compatible). */
export const LassoPromptRequestDtoSchema = z.object({
  prompt: z.string().min(1),
  sessionId: z.string().optional(),
  gcpAccessToken: z.string().optional(),
});

export type LassoPromptRequestDto = z.infer<typeof LassoPromptRequestDtoSchema>;
